import React from 'react';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';

function AdminLoadingScreen({ title = 'Preparing your dashboard', message = 'Restoring your session and workspace.' }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
      }}
    >
      <Paper
        sx={{
          width: '100%',
          maxWidth: 420,
          p: 4,
          textAlign: 'center',
          borderRadius: 6,
        }}
      >
        <CircularProgress size={34} />
        <Typography variant="h5" sx={{ mt: 3 }}>
          {title}
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1.5 }}>
          {message}
        </Typography>
      </Paper>
    </Box>
  );
}

export default AdminLoadingScreen;
